import { render, staticRenderFns } from "./ConfirmedPayment.vue?vue&type=template&id=d4c1968c&"
import script from "./ConfirmedPayment.vue?vue&type=script&lang=js&"
export * from "./ConfirmedPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports